import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'motion/react';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'festin_cookie_consent';

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className="fixed bottom-20 md:bottom-6 left-0 right-0 z-[200] px-4 flex justify-center pointer-events-none"
        >
          <div className="pointer-events-auto w-full max-w-2xl bg-[#161616] border border-white/10 rounded-2xl p-4 shadow-2xl flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Cookie className="w-5 h-5 text-[#FF5C00] shrink-0 mt-0.5 sm:mt-0" />
            <p className="text-sm text-gray-300 flex-1">
              Nous utilisons des cookies techniques nécessaires au fonctionnement de la plateforme (authentification, session).{' '}
              <Link to="/privacy" className="text-[#FF5C00] hover:underline font-semibold">
                En savoir plus
              </Link>
            </p>
            <div className="flex gap-2 shrink-0 w-full sm:w-auto">
              <button
                onClick={decline}
                className="flex-1 sm:flex-none px-4 py-2 text-sm font-bold text-gray-400 hover:text-white border border-white/10 rounded-xl transition-colors"
              >
                Refuser
              </button>
              <button
                onClick={accept}
                className="flex-1 sm:flex-none px-4 py-2 text-sm font-black text-white bg-[#FF5C00] hover:bg-[#ff6b1a] rounded-xl transition-colors"
              >
                Accepter
              </button>
            </div>
            <button onClick={decline} className="absolute top-3 right-3 text-gray-600 hover:text-white sm:hidden">
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
